import { useQuery, useRequestFetch } from '#imports'
import type { BlogPostResponse } from '../types/blog'

export function useBlogPost(slug: string) {
    const requestFetch = useRequestFetch()

    return useQuery<BlogPostResponse>(
        context => requestFetch<BlogPostResponse>(`/api/public/blog/posts/${slug}`, { signal: context?.signal }),
        {
            key: `content:blog-post-${slug}`,
            server: true,
        },
    )
}
